import { config } from '@abyss/ui/tools/config';

const { LagoonSDK } = require('./lagoonSDK');

const paanNamespace = 'sde-paan';
const paanSchema = {
  loadTables: true,
  loadForms: false,
};

const APP_ENV = config('APP_ENV');
const lagoonEnv = APP_ENV === 'local' ? 'dev' : APP_ENV;

export const paanLagoon = new LagoonSDK(paanNamespace, lagoonEnv, paanSchema);
